import React from "react";

const Activities = () => {
  return (
    <div className="gdlr-core-pbf-wrapper background-left-images kingster-body" id="activities-section">
      <div className="gdlr-core-pbf-background-wrap" id="div_983a_10">
        <div
          className="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
          data-parallax-speed="0.1"
          style={{ height: "427px", transform: "translate(0px, -33.8px)" }}
        ></div>
      </div>

      {/* Title */}
      <div className="gdlr-core-pbf-element">
        <div
          className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr col-md-6"
          style={{ paddingBottom: "40px", textAlign: "center" }}
        >
          <div className="gdlr-core-title-item-title-wrap clearfix text-center">
            <h3
              className="gdlr-core-title-item-title gdlr-core-skin-title" 
              style={{
                fontSize: "30px",
                fontWeight: 600,
                letterSpacing: 0,
                textTransform: "none",
                color: "#fff",
                marginRight: "30px",
              }}
            >
              Activities
            </h3>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="gdlr-core-pbf-wrapper-content gdlr-core-js">
        <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">

          {/* Developmental */}
          <div className="gdlr-core-pbf-column gdlr-core-column-20 gdlr-core-column-first">
            <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
              <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                <div className="gdlr-core-pbf-element">
                  <div
                    className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                  >
                    <div className="gdlr-core-title-item-title-wrap clearfix">
                      <h3 className="gdlr-core-title-item-title gdlr-core-skin-title" id="h3_983a_1">
                        Developmental
                      </h3>
                    </div>
                  </div>
                </div>

                <div className="gdlr-core-pbf-element">
                  <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align">
                    <div className="gdlr-core-text-box-item-content">
                      <p>
                        IIHS building was renovated and blessed by the parish priest,
                        Karaikal for starting GNM course in the presence of Rev. Mother
                        John Britto Mary Former Superior General, Rev. Sr. Celin Mary
                        former provincial of St. Joseph’s Province Trichy and all the
                        sisters of IIHS and then General Councillor for Medical Ministry
                        Dr. Sr. Alphonse Mary.
                      </p>
                    </div>
                  </div>
                  <div className="gdlr-core-pbf-element">
                    <div className="gdlr-core-button-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align">
                      <a
                        className="gdlr-core-button gdlr-core-button-transparent gdlr-core-button-no-border"
                        href="activities.html" id="gdlr-core-button-id-66813"
                      >
                        <span className="gdlr-core-content">Read More</span>
                        <i className="gdlr-core-pos-right fa fa-long-arrow-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Academical */}
          <div className="gdlr-core-pbf-column gdlr-core-column-20">
            <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
              <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                <div className="gdlr-core-pbf-element">
                  <div
                    className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                  >
                    <div className="gdlr-core-title-item-title-wrap clearfix">
                      <h3 className="gdlr-core-title-item-title gdlr-core-skin-title" id="h3_983a_1">
                        Academical
                      </h3>
                    </div>
                  </div>
                </div>

                <div className="gdlr-core-pbf-element">
                  <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align">
                    <div className="gdlr-core-text-box-item-content">
                      <p>
                        With the efforts of competent and committed faculty, our students
                        are trained in various subjects through audio visual aids and
                        online program. Students gain clinical experience in GH, Karaikal,
                        Community Health Center in Thirunallar and Nedungadu, De-addiction
                        centre in Karaikal and parent hospital in Mayiladuthurai.
                      </p>
                    </div>
                  </div>
                  <div className="gdlr-core-pbf-element">
                    <div className="gdlr-core-button-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align">
                      <a
                        className="gdlr-core-button gdlr-core-button-transparent gdlr-core-button-no-border"
                        href="activities-academic.html" id="gdlr-core-button-id-66813"
                      >
                        <span className="gdlr-core-content">Read More</span>
                        <i className="gdlr-core-pos-right fa fa-long-arrow-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Strengths & Achievements */}
          <div className="gdlr-core-pbf-column gdlr-core-column-20">
            <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
              <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                <div className="gdlr-core-pbf-element">
                  <div
                    className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                  >
                    <div className="gdlr-core-title-item-title-wrap clearfix">
                      <h3 className="gdlr-core-title-item-title gdlr-core-skin-title" id="h3_983a_1">
                        Strengths And Achievements
                      </h3>
                    </div>
                  </div>
                </div>

                <div className="gdlr-core-pbf-element">
                  <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align">
                    <div className="gdlr-core-text-box-item-content">
                      <p>
                        IIHS is blessed with unpolluted environment, adequate buildings,
                        and facilities supporting Government, Congregation, Province &
                        well-wishers. We are blessed with committed Director, Principal,
                        Sisters and staff. We do fill up all the seats for admission every
                        year. Centum results and many distinctions in all the subjects.
                      </p>
                    </div>
                  </div>
                  <div className="gdlr-core-pbf-element">
                    <div className="gdlr-core-button-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align">
                      <a
                        className="gdlr-core-button gdlr-core-button-transparent gdlr-core-button-no-border"
                        href="strengths-achievements.html" id="gdlr-core-button-id-66813"
                      >
                        <span className="gdlr-core-content">Read More</span>
                        <i className="gdlr-core-pos-right fa fa-long-arrow-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Activities;
